<section class="course-creation-error-dialog">
  <h2 class="dialog-title">{{ 'guidedCourseCreation.createCourse.errorDialog.title' | translate }}</h2>
  <p class="dialog-subtitle">{{ 'guidedCourseCreation.createCourse.errorDialog.subtitle' | translate }}</p>

  <div class="error-warning-box">
    <mat-icon class="warning-icon">warning</mat-icon>
    <div class="warning-content">
      <span class="warning-title">{{ data.errorMessage }}</span>
      <span class="warning-hint">{{ 'guidedCourseCreation.createCourse.errorDialog.retryHint' | translate }}</span>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button color="darkblue" (click)="onCancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button mat-stroked-button color="yellow" class="no-border filled" (click)="onTryAgain()">
      {{ 'guidedCourseCreation.createCourse.errorDialog.tryAgain' | translate }}
    </button>
  </div>
</section>
